<template>
	<view class="box">
		<view class="box_goods">
			<view class="box_goods_label">退款商品</view>
			<view class="box_goods_info">
				<view class="box_goods_info_img">
					<image src="@/static/uni.png" mode="widthFix"></image>
				</view>
				<view class="box_goods_info_right">
					<view class="box_goods_info_right_a">
						<view class="title">清澄白河马克杯-节日版</view>
						<view class="price">
							<text>¥</text>
							<text>79</text>
							<text>.98</text>
						</view>
					</view>
					<view class="box_goods_info_right_b">
						<text>白色</text>
						<text>x1</text>
					</view>
				</view>
			</view>
		</view>
		<view class="box_lx">
			<view class="box_lx_label">选择售后类型</view>
			<view class="box_lx_list">
				<view class="box_lx_list_item" @click="jump">
					<view class="left">
						<image src="@/static/icon/ic_tuikuan@2x.png" mode="widthFix"></image>
						<view class="left_info">
							<text>我要退款（无需退货）</text>
							<text>与卖家协商同意不用退货只退款</text>
						</view>
					</view>
					<uni-icons type="forward" color="#999999" size="20"></uni-icons>
				</view>
				<view class="box_lx_list_item" @click="jump">
					<view class="left">
						<image src="@/static/icon/ic_tuihuo@2x.png" mode="widthFix"></image>
						<view class="left_info">
							<text>我要退货退款</text>
							<text>已收到货，需要退还收到的货物</text>
						</view>
					</view>
					<uni-icons type="forward" color="#999999" size="20"></uni-icons>
				</view>
				<view class="box_lx_list_item" @click="jump">
					<view class="left">
						<image src="@/static/icon/ic_huanhuo@2x.png" mode="widthFix"></image>
						<view class="left_info">
							<text>换货</text>
							<text>已收到货，需要退还更换</text>
						</view>
					</view>
					<uni-icons type="forward" color="#999999" size="20"></uni-icons>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			jump() {
				uni.navigateTo({
					url: '/pages/spplyRefund/index'
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_goods {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.box_goods_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 32rpx;
			}
			.box_goods_info {
				display: flex;
				align-items: center;
				.box_goods_info_img {
					flex-shrink: 0;
					width: 180rpx;
					height: 180rpx;
					background: #FFFFFF;
					border-radius: 12rpx;
					border: 2rpx solid #F5F5F5;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 20rpx;
					image {
						width: 160rpx;
						height: 160rpx;
					}
				}
				.box_goods_info_right {
					flex: 1;
					height: 180rpx;
					display: flex;
					flex-direction: column;
					.box_goods_info_right_a {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.title {
							width: 320rpx;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.price {
							display: flex;
							align-items: center;
							text {
								&:nth-child(1) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 6rpx;
								}
								&:nth-child(2) {
									font-size: 28rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
								}
								&:nth-child(3) {
									font-size: 20rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
									margin-top: 6rpx;
								}
							}
						}
					}
					.box_goods_info_right_b {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 16rpx;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
				}
			}
		}
		.box_lx {
			width: 100%;
			padding: 28rpx 32rpx 0 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.box_lx_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 16rpx;
			}
			.box_lx_list {
				display: flex;
				flex-direction: column;
				.box_lx_list_item {
					width: 100%;
					height: 148rpx;
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 2rpx solid #F4F5F4;
					&:last-child {
						border: none !important;
					}
					.left {
						display: flex;
						align-items: center;
						image {
							flex-shrink: 0;
							width: 44rpx;
							height: 44rpx;
							margin-right: 24rpx;
						}
						.left_info {
							flex: 1;
							display: flex;
							flex-direction: column;
							text {
								&:nth-child(1) {
									font-size: 32rpx;
									font-family: PingFang SC-Semibold, PingFang SC;
									font-weight: 600;
									color: #333333;
								}
								&:nth-child(2) {
									font-size: 28rpx;
									font-family: PingFang SC-Regular, PingFang SC;
									font-weight: 400;
									color: #666666;
									margin-top: 16rpx;
								}
							}
						}
					}
				}
			}
		}
	}
</style>